var BraintreePayPal = (function ($, _, PaymentProviderBase, braintree, CheckoutSettings, PromiseUtil) {

	var BraintreePayPal = PaymentProviderBase.extend({

        type: 'paypal',
        paymentOption: CheckoutSettings.PaymentOption.BrainTreePayPal,
		_supportedTypes: braintreeSupportedTypes.paypal,
		_supportedOrderTypes: braintreeSupportedOrderTypes.paypal,

		initialize: function (attrs, opts) {
			this._init = new $.Deferred();

			this.braintree = opts.Braintree;
			this.paymentOption = opts.paymentOption || this.paymentOption;
            this.braintree.onSetupDone(this._init.resolve);
		    this._logger = opts.logger;
		},

		prepayment: function () {
			if (PromiseUtil.isResolved(this._init)) {
				return this.braintree.paypal.getPayload();
			} else {
				return PromiseUtil.rejected();
			}
		},

        complete: function (method) {
            var transactionData = {
                paymentType: 'braintree',
                selectedPaymentOption: this.paymentOption,
                paymentNonce: method.Nonce || '',
                paymentToken: method.Token || '',
                deviceData: this.braintree.kount.getDeviceData()
            };

            this._logger && this._logger('paypal');

            return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true });
		},

		ready: function (cb) {
			this._init.done(cb);
		}
	});

	return BraintreePayPal;
})($, _, PaymentProviderBase, braintree, CheckoutSettings, PromiseUtil);
